export const version = "address/5.6.0";
//# sourceMappingURL=_version.js.map